import {translate} from "../../../i18n";

const operatorLabels = {
    '=': '=',
    '!=': '&ne;',
    '>': '&gt;',
    '<': '&lt;',
    '>=': '&ge;',
    '<=': '&le;',
    'in_range': translate('in range'),
    'contain': translate('contain'),
    'not_contain': translate('not contain'),
    'start_with': translate('start with'),
    'not_start_with': translate('not start with'),
    'end_with': translate('end with'),
    'not_end_with': translate('not end with'),
    'in_list': translate('in list'),
    'is': translate('is')
};

export default operatorLabels;
